import { types } from "../types/types";

const initialState = {
    // Historial municipio (usuario normal) - sin cambios
    contingut: null,

    // Historial admin paginado (nuevo)
    historialAdmin: {
        contingut:      [],   // Filas de la página actual
        total:          0,    // Total de registros filtrados
        totalSinConcl:  0,    // Total sin conclusiones (para el badge)
        pagina:         1,
        porPagina:      10,
    },
    carregant: false,
};

export const configAplicacioReducer = (state = initialState, action) => {
    switch (action.type) {

        // Historial usuario normal (sin cambios)
        case types.configAplicacioRecuperarHistoric:
            return {
                ...state,
                contingut: action.contingut
            };

        // Historial admin paginado (nuevo)
        case types.configAplicacioRecuperarHistoricPaginat:
            return {
                ...state,
                historialAdmin: {
                    contingut:     action.payload.contingut,
                    total:         action.payload.total,
                    totalSinConcl: action.payload.totalSinConcl,
                    pagina:        action.payload.pagina,
                    porPagina:     action.payload.porPagina,
                }
            };

        // Loading state
        case types.configAplicacioSetCarregant:
            return {
                ...state,
                carregant: action.carregant
            };

        default:
            return state;
    }
}